import React, {useCallback, useEffect, useRef, useState} from "react";
import {Col, Row} from "react-bootstrap";
import ReactToPrint from "react-to-print";
import {getNotes} from "../services/APIClient";
import ExpandedHandoverView from "./ExpandedHandoverView";
import "./PrintClassResults.css";
import "./JiSiReportsOverview.css";

function PrintClassroomObservations({
  classDetails,
  students,
  studentsReadingScore,
  teachers,
  academicYear,
  gradeName,
  getReport,
}) {
  const componentRef = useRef();
  const [classNotes, setClassNotes] = useState([]);

  const fetchClassNotes = useCallback(() =>
    getNotes("class", classDetails.id, "ClassroomObservation")
      .then((response) => setClassNotes(response.data || []))
      .catch(() => setClassNotes([])), [classDetails.id]);

  useEffect(() => {
    fetchClassNotes();
  }, [fetchClassNotes]);

  return (
    <>
      <div className="jisi-hide-div jisi-landscape-print" ref={componentRef}>
        <Row className="mt-5 text-center">
          <Col><h3>{classDetails.name}</h3></Col>
          <Col><h3>{gradeName} Observations</h3></Col>
          <Col><h3>{academicYear}</h3></Col>
        </Row>
        {classNotes.length > 0 && (
          <Row className="mx-3 mb-3">
            <Col>
              <h4>Class Notes</h4>
              {classNotes.map((note) => (
                <div key={note.id} style={{marginBottom: 8}}>{note.note_text}</div>
              ))}
            </Col>
          </Row>
        )}
        <ExpandedHandoverView
          students={students}
          classid={classDetails.id}
          teachers={teachers}
          studentsReadingScore={studentsReadingScore}
          onSortData={() => {}}
          getReport={getReport}
          noteType="ClassroomObservation"
        />
      </div>
      <ReactToPrint
        content={() => componentRef.current}
        trigger={() => <button className="white-action-button">Print</button>}
        onBeforeGetContent={fetchClassNotes}
      />
    </>
  );
}

export default PrintClassroomObservations;
